/**
 * Permission names must match `PermissionDto.name` from `GET /api/permissions`.
 * Assign to roles via `PUT /api/roles/{roleName}/permissions` (`permissionNames`).
 */
export const APP_PERMISSIONS = {
  TodoListsRead: 'todolists.read',
  TodoListsCreate: 'todolists.create',
  TodoListsUpdate: 'todolists.update',
  TodoListsDelete: 'todolists.delete',
  TodoListsPurge: 'todolists.purge',

  TodoItemsRead: 'todoitems.read',
  TodoItemsCreate: 'todoitems.create',
  TodoItemsUpdate: 'todoitems.update',
  TodoItemsDelete: 'todoitems.delete',

  EssentialsRead: 'essentials.read',
  EssentialsCreate: 'essentials.create',
  EssentialsUpdate: 'essentials.update',
  EssentialsDelete: 'essentials.delete',

  EssentialTitlesRead: 'essentialtitles.read',
  EssentialTitlesCreate: 'essentialtitles.create',
  EssentialTitlesUpdate: 'essentialtitles.update',
  EssentialTitlesDelete: 'essentialtitles.delete',

  QuestionsRead: 'questions.read',
  QuestionsCreate: 'questions.create',
  QuestionsUpdate: 'questions.update',
  QuestionsDelete: 'questions.delete',

  AnswersRead: 'answers.read',
  AnswersCreate: 'answers.create',
  AnswersUpdate: 'answers.update',
  AnswersDelete: 'answers.delete',

  EvaluationsRead: 'evaluations.read',
  EvaluationsCreate: 'evaluations.create',
  EvaluationsUpdate: 'evaluations.update',
  EvaluationsDelete: 'evaluations.delete',
  EvaluationsPrint: 'evaluations.print',

  AssessmentsRead: 'assessments.read',
  AssessmentsCreate: 'assessments.create',
  AssessmentsUpdate: 'assessments.update',

  AssessmentClimateImpactRead: 'assessmentclimateimpact.read',
  AssessmentClimateImpactWrite: 'assessmentclimateimpact.write',

  AssessmentVulnerabilityRead: 'assessmentvulnerability.read',
  AssessmentVulnerabilityWrite: 'assessmentvulnerability.write',

  ReferenceDataRead: 'referencedata.read',

  HazardCatalogRead: 'hazardcatalog.read',
  HazardCatalogCreate: 'hazardcatalog.create',
  HazardCatalogUpdate: 'hazardcatalog.update',
  HazardCatalogDelete: 'hazardcatalog.delete',

  HazardBaselineLevelsRead: 'hazardbaselinelevels.read',
  HazardBaselineInputsRead: 'hazardbaselineinputs.read',
  HazardBaselineInputsWrite: 'hazardbaselineinputs.write',
  HazardBaselineRead: 'hazardbaseline.read',
  HazardBaselineCalculate: 'hazardbaseline.calculate',

  RegionalClimateReferenceRead: 'regionalclimatereference.read',
  RegionalClimateReferenceCreate: 'regionalclimatereference.create',
  RegionalClimateReferenceUpdate: 'regionalclimatereference.update',
  RegionalClimateReferenceToggleStatus: 'regionalclimatereference.togglestatus',

  ClimateVariableRead: 'climatevariable.read',
  ClimateVariableCreate: 'climatevariable.create',
  ClimateVariableUpdate: 'climatevariable.update',
  ClimateVariableToggleStatus: 'climatevariable.togglestatus',

  HazardFamilyClimateVariableRead: 'hazardfamilyclimatevariable.read',
  HazardFamilyClimateVariableCreate: 'hazardfamilyclimatevariable.create',
  HazardFamilyClimateVariableToggleStatus: 'hazardfamilyclimatevariable.togglestatus',

  ClimateScenarioRead: 'climatescenario.read',
  ClimateScenarioCreate: 'climatescenario.create',
  ClimateScenarioUpdate: 'climatescenario.update',
  ClimateScenarioToggleStatus: 'climatescenario.togglestatus',

  LocalNationalClimateReferenceRead: 'localnationalclimatereference.read',
  LocalNationalClimateReferenceCreate: 'localnationalclimatereference.create',
  LocalNationalClimateReferenceUpdate: 'localnationalclimatereference.update',
  LocalNationalClimateReferenceToggleStatus: 'localnationalclimatereference.togglestatus',

  VulnerabilityIndicatorsRead: 'vulnerabilityindicators.read',
  VulnerabilityCalculationCalculate: 'vulnerabilitycalculation.calculate',

  UsersRead: 'users.read',
  UsersUpdate: 'users.update',

  RolesRead: 'roles.read',
  RolesCreate: 'roles.create',
  RolesUpdate: 'roles.update',
  RolesDelete: 'roles.delete',

  RolesPermissionsUpdate: 'roles.permissions.update',
} as const;

/** API role names returned by Users `manage/info-v2` (e.g. `roles` array). */
export const APP_ROLES = {
  Administrator: 'Administrator',
} as const;
